
// var analytics = require('../analytics');
const isVisible = require('mode-front-end/resources/assets/js/dom/isInViewport')

// Autoplay looping video, cross-browser
// require('viewport-units-buggyfill').init();
require('objectFitPolyfill');

// import enableInlineVideo from 'iphone-inline-video';

// Plyr
var plyr = require('plyr');

export default (function(window, document, undefined) {

  const scrollTopProperty = typeof window.scrollY === "undefined" ? 'pageYOffset' : 'scrollY'

  let videoScrollHandler = function() {

    let videosContainers = Array.from(document.querySelectorAll('.individual-work--video a'));
    videosContainers.forEach(function(container) {

      let video = container.querySelector('video')
      let scrollTop = window[scrollTopProperty]

      if (!video) {
        return;
      }

      if (window.innerHeight > ($(container).offset().top - scrollTop)) {

        if (video.readyState !== 4 && video.readyState !== 1) {
          video.addEventListener('loadstart', function() {
            video.play().then(() => {
              container.classList.add('video-autoplay')
            });
          });
          return;
        }

        container.classList.add('video-autoplay')
        video.play()
      } else {
        container.classList.remove('video-autoplay')
        video.pause();
      }
    });
  }

  function loadVideos() {

    let loadAllVideosForPage = function(useSmall) {
      let videos = Array.from(document.querySelectorAll('video[data-src]'));

      videos.forEach((videoElem) => {

        var source = videoElem.getAttribute('data-src');
        if (useSmall) {
          let smallSource = videoElem.getAttribute('data-src-sm');
          if (smallSource) {
            source = smallSource;
          }
        }

        if (!source || source.length == '') {
          return;
        }

        // set the sources for every body
        videoElem.setAttribute('src', source);
        var sourceElem = document.createElement('source');
        sourceElem.setAttribute('src', source);
        sourceElem.setAttribute('type', 'video/mp4');

        videoElem.appendChild(sourceElem);
      });

      setupLoadedContent();
    };

    window.removeEventListener('optimizedScroll', videoScrollHandler);
    window.addEventListener('optimizedScroll', videoScrollHandler);

    Breakpoints.on({
      name: "lt-tablet",
      matched: function() {
        loadAllVideosForPage(true);
        videoScrollHandler();
      },
      exit: function() {
      },
    });

    Breakpoints.on({
      name: 'tablet',
      matched: function() {
        loadAllVideosForPage(false);
        videoScrollHandler();
      }
    })
  }

  function setupLoadedContent() {

    // // Work Blocks
    // var loopContainers = Array.from(document.querySelectorAll('.individual-work--video a'));

    // loopContainers.forEach((container) => {
    //   let loop = container.querySelector('.js-vimeo-loop')

    //   if (!loop) {
    //     return;
    //   }

    //   loop.play().catch((e) => console.log(e.message));

    //   // Pull video from Vimeo into element
    //   // enableInlineVideo(loop, { iPad: true });

    //   // container.addEventListener('mouseenter', (e) => {
    //   //   if (loop.paused) {
    //   //     loop.play();
    //   //   }
    //   // })

    //   // container.addEventListener('mouseleave', (e) => {
    //   //   loop.pause();
    //   // })
    // })

    // Work Detail Page
    let videoContainer = Array.from(document.querySelectorAll('.js-video-controls'));

    let options = {
      controls: ['play-large', 'play', 'progress', 'mute', 'volume', 'captions', 'fullscreen'],
      iconUrl: '/img/svg/sprites/video.svg',
      iconPrefix: 'v'
    };

    videoContainer.forEach(function(container, index) {

      if (container.querySelector('.plyr--video')) {
        return;
      }

      let player = plyr.setup(container, options)[0];
      let timer;
      let video = container.querySelector('video')
      let videoOverlay = container.querySelector('.overlay-copy')
      let videoWrapper = container.querySelector('.plyr__video-wrapper')

      if (videoWrapper && video) {
        // Add the poster image
        let posterImageUrl = video.getAttribute('poster')
        if (posterImageUrl !== null && posterImageUrl !== 'null' && posterImageUrl.length > 0) {

          if (!videoWrapper.parentNode.querySelector('custom-poster-image')) {
            let posterImage = document.createElement('img')
            posterImage.src = posterImageUrl
            posterImage.classList.add('custom-poster-image')
            videoWrapper.parentNode.appendChild(posterImage)
          }
        }

        if (video.dataset.showTitle == 1) {
          let lgPlayButton = container.querySelector('.plyr').querySelector('.plyr__play-large');

          if (!lgPlayButton.querySelector('video-title')) {
            let videoTitle = document.createElement('span')
            videoTitle.classList.add('video-title')
            videoTitle.textContent = video.dataset.title
            lgPlayButton.appendChild(videoTitle)
          }
        }
      }

      player.on('pause', function(e) {
        clearInterval(timer);
        this.classList.add('plyr--paused');
        if(videoOverlay){
          videoOverlay.classList.remove('playing');
        }
      });

      player.on('play', function(e) {
        this.classList.remove('plyr--paused');
        if(videoOverlay){
          videoOverlay.classList.add('playing');
        }
      });

      player.on('ended', function(e) {
        this.classList.remove('plyr--paused');
        if(videoOverlay){
          videoOverlay.classList.remove('playing');
        }
      });

      // Fix overlapping header in fullscreen mode
      player.on('enterfullscreen', function(e) {
        if ( $('.plyr--fullscreen-active').length ) {
          document.body.classList.add('is-fullscreen');
        }
      });

      player.on('exitfullscreen', function(e) {
        document.body.classList.remove('is-fullscreen');
      });

      // Track Percentage Watched
      var marks = [10, 20, 30, 40, 50, 60, 70, 80, 90],
          marksReached = [],
          marksWatched = [];

      function trackPercentageCompleted(progress) {
        var watchedPercentage = progress;

        // // GA: Track video player
        // map(marks, (function(mark, index) {
        //   // % Reached
        //   if (marksReached.indexOf(mark) < 0 && watchedPercentage >= mark) {
        //     marksReached.push(mark);

        //     analytics.trackEvent({
        //       'eventCategory' : 'Video Tracking',
        //       'eventAction' : 'Reached ' + mark + '%',
        //       'eventLabel'  : window.location.pathname + ' | ' + videoTitle,
        //       'eventValue'  : watchedPercentage
        //     });
        //   }
        // }).bind(this));
      }

      player.on('play', function(e){
        timer = setInterval((function() {
          var currentTime = player.getCurrentTime();

          if (currentTime > 0) {
            var videoDuration = player.getDuration();
            var progressPercentage = Math.round((currentTime / videoDuration) * 100);
            trackPercentageCompleted(progressPercentage);
          }
        }).bind(this), 1000);
      });

      // GA Events
      var playClickCount = 0, finishedCount = 0;
      var videoTitle = player.getMedia().getAttribute('data-title');

      player.on('play', function(e){
        playClickCount++;
        // analytics.trackEvent({
        //   'eventCategory' : 'Video Tracking',
        //   'eventAction'   : 'Clicked Play ' + playClickCount + 'x',
        //   'eventLabel'    : window.location.pathname + ' | ' + videoTitle
        // });
      });

      player.on('ended', function(e){
        clearInterval(timer);

        finishedCount++;
        // analytics.trackEvent({
        //   'eventCategory' : 'Video Tracking',
        //   'eventAction'   : 'Finished Video ' + finishedCount + 'x',
        //   'eventLabel'    : window.location.pathname + ' | ' + videoTitle
        // });
      });
    });
  }

  function init() {

    if (document.readyState !== 'complete') {
      window.addEventListener('load', (e) => { loadVideos(); });
    } else {
      loadVideos();
    }
  }

  // ------------------------------
  // Public
  // ------------------------------

  return {
    init: init
  };

})(window, document);
